const productNameMapping = {
  ctm: 'Route Monitoring',
  ja: 'Junction Analytics',
  ll: 'Move',
  od: 'O/D Analysis',
  'rer-test': 'Road Event Reporter Test',
  rer: 'Road Event Reporter',
  ts: 'Traffic Stats',
  tv: 'Traffic Viewer',
};

export function getProductName(productId: string) {
  const mappingKey = Object.keys(productNameMapping).find(key =>
    productId.startsWith(key),
  ) as keyof typeof productNameMapping;

  if (!mappingKey) {
    throw new Error(`Unknown product id "${productId}".`);
  }

  return productNameMapping[mappingKey];
}
